import depositTabs from '@/components/wallet/shared/deposit-tabs/deposit-tabs.vue';
import pendingRequestsListDeposit from '@/components/wallet/pending-requests/pending-requests-list-deposit/pending-requests-list-deposit.vue';
import pendingRequestsListWithdrawal from '@/components/wallet/pending-requests/pending-requests-list-withdrawal/pending-requests-list-withdrawal.vue';

const TAB_DEPOSITS = 'deposits';
const TAB_WITHDRAWALS = 'withdrawals';

export default {
  components: {
    depositTabs,
    pendingRequestsListDeposit,
    pendingRequestsListWithdrawal,
  },
  data() {
    return {
      activeTab: this.$route.query.subTab === TAB_WITHDRAWALS ? TAB_WITHDRAWALS : TAB_DEPOSITS,
      tabs: [
        { name: TAB_DEPOSITS, title: 'Deposits' },
        { name: TAB_WITHDRAWALS, title: 'Withdrawals' },
      ],
    };
  },
  computed: {
    showDepositsTab() {
      return this.activeTab === TAB_DEPOSITS;
    },
    showWithdrawalsTab() {
      return this.activeTab === TAB_WITHDRAWALS;
    },
  },
  methods: {
    tabChange(name) {
      this.activeTab = name;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/wallet-pending/wallet-pending.js